import { rem } from 'src/styles/function';
import styled from 'styled-components';

/**
 * @name 전단 상단 고정 이미지
 */
export const StyledFixedImage = styled.section`
  width: 100%;
  padding-bottom: ${rem(20)};
  img {
    width: 100%;
  }
`;

/**
 * @name 전단 허브 스타일 컴포넌트
 */
export const StyledLeafletHub = styled.main`
  padding: 0 ${rem(20)};
`;

/**
 * @name 전단 허브 스타일 컴포넌트
 */
export const StyledFixedBanner = styled.ul`
  display: grid;
  grid-template-columns: auto auto;
  gap: 1rem;
  li {
    img {
      width: 100%;
    }
  }
`;

/**
 * @name 전단 메뉴 스타일 컴포넌트
 */
export const StyledMenuBanner = styled.ul`
  margin-top: ${rem(20)};
  li {
    margin-bottom: ${rem(10)};
    img {
      width: 100%;
    }
  }
`;
